import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { getFormattedDateTime } from "utils/helper";

const NotesCell = ({ row, field, updateTrackerStatus }) => {
  const [open, setOpen] = useState(false);
  const [noteText, setNoteText] = useState(row[field] || "");

  const handleSave = () => {
    updateTrackerStatus(row.patient_id, field, noteText);
    setOpen(false);
  };

  return (
    <Box>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography
          variant="body2"
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 180,
          }}
        >
          {noteText
            ? noteText.slice(0, 50) + (noteText.length > 50 ? "..." : "")
            : "No notes"}
        </Typography>
        <Button size="small" onClick={() => setOpen(true)}>
          View / Edit
        </Button>
      </Box>
      {noteText && noteText !== "" && (
        <Typography variant="caption">
          Updated By: {row.last_updated_by} on{" "}
          {getFormattedDateTime(row.last_updated_date)}
        </Typography>
      )}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Notes</DialogTitle>
        <DialogContent>
          <TextField
            multiline
            minRows={6}
            fullWidth
            variant="outlined"
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            placeholder="Add follow-ups, tracking, or other notes here..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default NotesCell;
